import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  clearAllButtonText: {
    defaultMessage: 'Clear all',
    id: '+sf9bU',
    description: 'Text of the clear products button',
  },
  defaultTableCount: {
    defaultMessage: '{count, plural, one {# Item added} other {# Items added}}',
    id: 'uu421b',
    description: 'Count of items added to table.',
  },
  searchProductsPlaceholder: {
    defaultMessage: 'Search product name or SKU',
    id: 'yJ8joo',
    description: 'Placeholder text for the search products input',
  },
  dangerousGoodsWarning: {
    defaultMessage: 'Please confirm that all applicable items have been marked as dangerous goods.',
    id: 'EmoGic',
    description: 'Warning message for dangerous goods',
  },
  dangerousGoodsCheckboxLabel: {
    defaultMessage: 'I confirm all dangerous goods have been properly marked.',
    id: 'z8mRjs',
    description: 'Label for dangerous goods checkbox',
  },
  dangerousGoodsLearnMoreLink: {
    defaultMessage: 'Learn more',
    id: 'iNjWqn',
    description: 'Link to learn more about dangerous goods',
  },
  submitAsnBannerCloseButtonText: {
    defaultMessage: 'Close',
    id: 'qBays+',
    description: 'Text for the close button in the submit ASN banner',
  },
  submitAsnBannerSubmitButtonText: {
    defaultMessage: 'Submit notice',
    id: 'aSJnQY',
    description: 'Text for the submit button in the submit ASN banner',
  },
  confirmSubmitHeader: {
    defaultMessage: 'Confirm Shipping Notice Submission',
    description: 'Header text for user to confirm they want to submit the Advance Shipping Notice',
    id: '1yXKb5',
  },
  confirmSubmitBody: {
    defaultMessage:
      'Are you sure you want to submit your notice? Since this notice is used to notify the warehouse and create the Warehouse Receiving Labels necessary for receiving, <b>you cannot make any changes</b> to this notice once submitted.',
    id: 'BjH6hW',
    description: 'Body text for user to confirm they want to submit the Advance Shipping Notice',
  },
});
